import React from 'react';
import { Button } from '@/components/ui/button';

export default function CelebrationModal({ 
  type, 
  moduleNumber, 
  moduleTitle,
  onClose 
}) {
  const getModuleSkillName = (number) => {
    const skills = {
      1: 'Understanding Your Brain',
      2: 'Self-Compassion',
      3: 'Urge Surfing',
      4: 'Identifying Your Needs',
      5: 'Building Alternatives',
      6: 'Living Your Values',
      7: 'Emotional Regulation',
      8: 'Environmental Design',
      9: 'Thought Defusion',
      10: 'Building Alternatives',
      11: 'Relationship Skills',
      12: 'Life Purpose & Meaning',
      13: 'Advanced Relapse Prevention',
      14: 'Mentorship & Giving Back'
    };
    return skills[number] || 'New Skill';
  };

  // Individual module completion
  if (type === 'module' && moduleNumber) {
    return (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50 animate-fade-in">
        <div className="bg-white rounded-2xl p-8 max-w-sm w-full text-center space-y-4 shadow-2xl animate-slide-up">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold text-[#2F3A3D]">
            Module {moduleNumber} complete!
          </h2>
          <p className="text-lg text-[#5E6A6E] leading-relaxed">
            <span className="font-semibold text-[#8FAF9A]">{getModuleSkillName(moduleNumber)}</span> is now part of your toolkit.
          </p>
          <Button
            onClick={onClose}
            className="button-primary w-full rounded-full px-8 py-5 h-auto text-lg font-medium mt-6"
          >
            Continue
          </Button>
        </div>
      </div>
    );
  }

  // All modules completed
  if (type === 'all_modules') {
    return (
      <div className="fixed inset-0 bg-black/60 flex items-center justify-center p-4 z-50 animate-fade-in">
        <div className="bg-white rounded-3xl p-8 max-w-lg w-full text-center space-y-6 shadow-2xl animate-slide-up overflow-y-auto max-h-[90vh]">
          <div className="text-7xl mb-4">🎉</div>
          <h2 className="text-3xl font-bold text-[#2F3A3D]">
            You completed all 14 modules!
          </h2>
          
          <div className="text-left bg-[#F4F6F5] rounded-2xl p-6 space-y-4">
            <p className="text-base text-[#2F3A3D] leading-relaxed font-medium">
              You now have:
            </p>
            <ul className="space-y-2 text-sm text-[#2F3A3D]">
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Understanding of how your brain works</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Self-compassion to fuel your growth</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Urge surfing skills to ride difficult moments</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Clarity on what you really need</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Healthy alternatives that meet those needs</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Values to guide your choices</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Emotional regulation skills</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>An environment designed to support your growth</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Thought defusion and psychological flexibility</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>A life filled with meaningful alternatives</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Relationship and intimacy skills</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Purpose and meaning to guide your life</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Advanced relapse prevention strategies</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#6F8C9B] flex-shrink-0">✓</span>
                <span>Capacity to mentor and help others</span>
              </li>
            </ul>
          </div>

          <div className="space-y-4 text-left px-2">
            <p className="text-base text-[#2F3A3D] leading-relaxed">
              You&apos;ve traveled from struggling to thriving to serving. These aren&apos;t skills you learn once—they&apos;re skills you strengthen through practice.
            </p>
            <p className="text-base text-[#2F3A3D] leading-relaxed font-medium">
              You&apos;re not just recovered. You&apos;re equipped to help others on their journey.
            </p>
            <p className="text-lg text-[#6F8C9B] leading-relaxed font-semibold text-center pt-2">
              Welcome to the rest of your life.
            </p>
          </div>

          <Button
            onClick={onClose}
            className="button-primary w-full rounded-full px-8 py-6 h-auto text-lg font-semibold mt-4"
          >
            Continue Building &amp; Serving
          </Button>
        </div>
      </div>
    );
  }

  return null;
}
